import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLeftPoint = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M6.88094 12.5467C6.75427 12.5467 6.6276 12.5001 6.5276 12.4001L2.48094 8.35341C2.2876 8.16008 2.2876 7.84008 2.48094 7.64674L6.5276 3.60008C6.72094 3.40674 7.04094 3.40674 7.23427 3.60008C7.4276 3.79341 7.4276 4.11341 7.23427 4.30674L3.54094 8.00008L7.23427 11.6934C7.4276 11.8867 7.4276 12.2067 7.23427 12.4001C7.14094 12.5001 7.0076 12.5467 6.88094 12.5467Z" }), /* @__PURE__ */ _jsx("path", { d: "M14.1653 8.5H2.94531C2.67198 8.5 2.44531 8.27333 2.44531 8C2.44531 7.72667 2.67198 7.5 2.94531 7.5H14.1653C14.4386 7.5 14.6653 7.72667 14.6653 8C14.6653 8.27333 14.4386 8.5 14.1653 8.5Z" })]
});
export default SvgLeftPoint;
